import { createNavigation } from 'next-intl/navigation';

import { routing } from 'src/i18n/routing';

const { useRouter } = createNavigation(routing);

export { useRouter };
